import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import moment from "moment";

import CancelIcon from "@material-ui/icons/Cancel";

import { useStyles } from "./UserNotice.css";
import UserHeader from "../../../Components/NavBar/User/UserHeader/UserHeader";
import { connect } from "react-redux";
import Axios from "axios";
import { url } from "../../../Config/Config";
import CustomEmptyMessage from "../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import CustomSiteLoader from "../../../Components/CustomSiteLoader/CustomSiteLoader";
import { publicImageUrl } from "../../../Config/publicImageUrl";
import { engMonths } from "../../../Components/Data/Months";
import { years } from "../../../Components/Data/Session";
import { getUserRefreshToken } from "../../../Redux/Actions/actions";
import PageTitle from "../../../Components/PageTitle/PageTitle";

class UserNotice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notices: [],
      isEmpty: false,
      detailStatus: false,
      schoolDetails: {},
      month: moment(new Date()).format("MMM"),
      year: moment(new Date()).format("YYYY"),
    };
  }

  componentDidMount() {
    this.getNotices();
    this.getSchoolInfo();
  }

  getSchoolInfo = async () => {
    const response = await Axios.get(`${url}/api/setting`, {});
    if (response.data) {
      this.setState({ schoolDetails: response.data });
    }
  };

  getNotices = async () => {
    try {
      const response = await Axios.get(`${url}/api/notices`, {
        headers: {
          Authorization: `Bearer ${this.props.userToken}`,
        },
      });
      if (response.data.notices.length !== 0) {
        this.setState({
          notices: response.data.notices,
          isEmpty: false,
        });
      } else {
        this.setState({
          notices: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.userRefreshToken };
        this.props.getUserRefreshToken(refreshToken, this.props.role);
        this.getNotices();
      }
    }
  };

  handleDetailStatus = (detailData) => {
    this.setState({
      detailStatus: true,
      detailData,
    });
  };

  handleCancelDetail = () => {
    this.setState({
      detailStatus: false,
    });
  };

  compare = (a, b) => {
    const nameA = a.createdAt;
    const nameB = b.createdAt;

    let comparison = 0;
    if (nameA < nameB) {
      comparison = 1;
    } else if (nameA > nameB) {
      comparison = -1;
    }
    return comparison;
  };

  render() {
    const { classes } = this.props;
    const { detailData, schoolDetails } = this.state;
    let filtered = this.state.notices.filter((data) => {
      return (
        moment(data.createdAt).format("YYYY") === this.state.year &&
        moment(data.createdAt).format("MMMM") === this.state.month
      );
    });
    filtered.sort(this.compare);
    return (
      <div className={classes.root}>
        <UserHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />
          <div className={classes.sectionDesktop}>
            <PageTitle title="Notices" refreshUrl={this.props.match.url} />
          </div>
          <div className={classes.fieldStyle}>
            <TextField
              name="year"
              select
              fullWidth
              label="Notice Year"
              variant="outlined"
              margin="normal"
              SelectProps={{ native: true }}
              style={{ marginRight: 10 }}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              value={this.state.year}
              onChange={(e) => this.setState({ year: e.target.value })}
            >
              <option value="">Select Any One</option>
              {years.map((year, index) => (
                <option key={index} value={year}>
                  {year}
                </option>
              ))}
            </TextField>
            <TextField
              name="month"
              select
              fullWidth
              label="Notice Month"
              variant="outlined"
              margin="normal"
              SelectProps={{ native: true }}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline,
                  focused: classes.focused,
                },
              }}
              InputLabelProps={{
                classes: {
                  root: classes.labelRoot,
                  focused: classes.labelFocused,
                },
                shrink: true,
              }}
              value={this.state.month}
              onChange={(e) => this.setState({ month: e.target.value })}
            >
              <option value="">Select Any One</option>
              {engMonths.map((month, index) => (
                <option key={index} value={month}>
                  {month}
                </option>
              ))}
            </TextField>
          </div>

          {this.state.notices.length !== 0 ? (
            <div>
              <div>
                {filtered.length !== 0 ? (
                  <Grid container spacing={3}>
                    {this.state.detailStatus && (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                        className={classes.detailGrid}
                      >
                        <Paper className={classes.detailPaper}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {schoolDetails.schoolLogo && (
                              <img
                                src={`${publicImageUrl}/${schoolDetails.schoolLogo}`}
                                alt={schoolDetails.schoolName}
                                style={{ width: 50, height: 50 }}
                              />
                            )}
                            <div style={{ flexGrow: 1 }}>
                              <div>{schoolDetails.schoolName}</div>
                              <div>{schoolDetails.address}</div>
                            </div>
                            <Tooltip
                              arrow
                              title="Cancel"
                              onClick={this.handleCancelDetail}
                            >
                              <CancelIcon />
                            </Tooltip>
                          </div>
                          <p style={{ fontSize: 18, fontWeight: "bold" }}>
                            {detailData.title}
                          </p>
                          <p>{detailData.description}</p>

                          <div>
                            {schoolDetails.landLineNumber},
                            {schoolDetails.mobileNumber},{schoolDetails.email}
                          </div>
                        </Paper>
                      </Grid>
                    )}
                    {filtered.map((notice, index) => (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        lg={4}
                        xl={4}
                        key={index}
                      >
                        <Paper
                          className={classes.paper}
                          onClick={() => this.handleDetailStatus(notice)}
                        >
                          <div
                            style={{
                              fontSize: 20,
                              fontWeight: "bold",
                            }}
                          >
                            {notice.title}
                          </div>
                          <div>- {moment(notice.createdAt).format("LL")}</div>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <CustomEmptyMessage
                    description={`No new notices in this month ${this.state.month}`}
                  />
                )}
              </div>
            </div>
          ) : this.state.isEmpty ? (
            <CustomEmptyMessage />
          ) : (
            <CustomSiteLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.UserReducer.userId,
    userToken: state.UserReducer.userToken,
    userRefreshToken: state.UserReducer.userRefreshToken,
    role: state.UserReducer.role,
    isUser: state.UserReducer.isUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserRefreshToken: (refreshToken, role) => {
      dispatch(getUserRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(UserNotice));
